import { Fragment } from "react";

import { prop, define } from "@/components/builder/utils";

import BasePreview from "../../base";

import { useFormFieldContext } from "./context";

function FormDatePreview({ ...props }) {
  const { field: { placeholder } } = useFormFieldContext()

  return <BasePreview {...props}>
    <input placeholder={placeholder} type="date" />
  </BasePreview>
}

export default define('form-date', FormDatePreview, Fragment)
  .shared(prop.share('FormDate', 'form-date'))
  .property(prop.predefined.customClass())
  .property(...prop.predefined.borders())
  .property(...prop.predefined.appearance())
  .property(...prop.predefined.typography())
  .defaultProps({
    borderColor: {
      hex: "#b7b7b9",
      opacity: 100,
    },
    space: {
      padding: 'pt-1 pb-1 pl-2 pr-2',
    },
    border: {
      radius: {
        rounded: "sm",
      },
      width: {
        border: "1",
      },
      color: "gray-400",
    },
    size: {
      width: "w-full",
      height: "min-h-8",
    },
  })
  .build()

